import React, { CSSProperties } from 'react';

interface IProps {
  style?: CSSProperties;

  [prop: string]: unknown;
}

export default ({ style, ...rest }: IProps) => {
  const defaultStyle = { width: 50, height: 50 };
  const styles = { ...defaultStyle, ...style };

  return (
    <svg xmlns="http://www.w3.org/2000/svg" style={styles} width={styles.width} height={styles.height}
         viewBox="0 0 50 50" fill="none" {...rest}>
      <path opacity="0.24"
            d="M25 31.25C31.9036 31.25 37.5 25.6536 37.5 18.75C37.5 11.8464 31.9036 6.25 25 6.25C18.0964 6.25 12.5 11.8464 12.5 18.75C12.5 25.6536 18.0964 31.25 25 31.25Z"
            fill="#348AEB" />
      <path
        d="M25 31.25C31.9036 31.25 37.5 25.6536 37.5 18.75C37.5 11.8464 31.9036 6.25 25 6.25C18.0964 6.25 12.5 11.8464 12.5 18.75C12.5 25.6536 18.0964 31.25 25 31.25Z"
        stroke="#348AEB" strokeWidth="2" strokeMiterlimit="10" />
      <path
        d="M6.05469 42.1878C7.97448 38.8619 10.736 36.1 14.0616 34.1797C17.3873 32.2595 21.1598 31.2485 25 31.2485C28.8402 31.2485 32.6127 32.2595 35.9384 34.1797C39.264 36.1 42.0255 38.8619 43.9453 42.1878"
        stroke="#348AEB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
